import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _19_CULTURAL_ACTIVITIES:Partial<EcosystemServiceModel> ={
  id:'cultural-activities',
  pos:19,
  image: "/images/ecoservices/cultural_activities.jpg",
  code: ["3.1.2.3"],
  unit:'cultural activities',
  assetType:'socialUses',
  serviceType: 'cultural',
  valuationMethods:[
    {
      id: 'travelcost',
      name:"Travel Cost",
      unit: "visitor",
      element: "Visitors",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    },
    {
      id: 'contingent',
      name:"Contingent Valuation",
      unit: "person",
      element: "Population",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    },
    {
      id: 'project',
      name:"Project Budget",
      unit: "projects",
      element: "Projects",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
